import { IControlMeetingDetailsDTO } from '../../api/control.dao';
import { MeetingSyncData, OnSyncEventBody } from './index';
import { OnSyncEventType } from '../../api/events.dao';

export abstract class IMeetingChangeset<T extends OnSyncEventBody> {
    abstract applyChangesToMeeting(meeting: Partial<IControlMeetingDetailsDTO>): Partial<IControlMeetingDetailsDTO>;

    public get type(): OnSyncEventType {
        return this.syncData.type;
    }

    public getChangeset(): T {
        return this.syncData.body as T;
    }

    constructor(private readonly syncData: MeetingSyncData) {}
}
